import request from '../helpers/request';
import helpers from '../helpers/common';

const actionLogs = {};

actionLogs.getData = async (filters = {}) => {
    helpers.addForcedMerchantID(filters);
    return request.get('/transactions/action-logs', filters, false);
};

actionLogs.getPaymentPageOpens = (filters = {}) => {
    helpers.addForcedMerchantID(filters);
    return request.get('/transactions/payment-page-opens', filters, false);
};

export default actionLogs;














